import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "flex h-32 items-center border-b border-gray-100 dark:border-slate-800" }
const _hoisted_2 = { class: "lg ml-auto lg:ml-20" }
const _hoisted_3 = { class: "mobile-menu relative mr-5 md:hidden" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-bars text-2xl group-hover:text-gray-300 dark:text-gray-400" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "fixed left-0 top-20 z-50 mt-6 w-full bg-white p-5 pb-0 dark:bg-dark"
}
const _hoisted_7 = { class: "desktop-menu hidden flex-row items-center md:flex" }
const _hoisted_8 = { class: "flex h-24 items-center border-r-2 border-gray-100 p-5 py-3 text-lg text-gray-500 dark:border-slate-800 dark:text-gray-300" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-warehouse mr-4 flex text-gray-400 group-hover:bg-gray-500 group-hover:text-gray-200 dark:bg-extraDark dark:text-gray-500 dark:group-hover:bg-gray-700" }, null, -1)
const _hoisted_10 = { class: "h-24 items-center border-r-2 border-gray-100 p-5 py-3 text-center text-lg text-gray-500 dark:border-slate-800 dark:text-gray-300" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-location-pin mr-4 flex text-gray-400 group-hover:bg-gray-500 group-hover:text-gray-200 dark:bg-extraDark dark:text-gray-500 dark:group-hover:bg-gray-700" }),
  /*#__PURE__*/_createElementVNode("span", { class: "flex flex-col text-center" }, [
    /*#__PURE__*/_createTextVNode(" Gas voorraad "),
    /*#__PURE__*/_createElementVNode("span", { class: "-mt-1 text-sm italic text-gray-400 group-hover:text-white" }, "per locatie")
  ])
], -1)
const _hoisted_12 = { class: "flex h-24 items-center border-r-2 border-gray-100 p-5 py-3 text-lg text-gray-500 dark:border-slate-800 dark:text-gray-300" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-fire-flame-simple mr-4 flex text-gray-400 group-hover:bg-gray-500 group-hover:text-gray-200 dark:bg-extraDark dark:text-gray-500 dark:group-hover:bg-gray-700" }, null, -1)
const _hoisted_14 = { class: "flex h-24 items-center px-5 text-lg text-gray-500 dark:text-gray-300" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-oil-can mr-4 flex text-gray-400 group-hover:bg-gray-500 group-hover:text-gray-200 dark:bg-extraDark dark:text-gray-500 dark:group-hover:bg-gray-700" }, null, -1)
const _hoisted_16 = { class: "ml-0 flex flex-row md:ml-auto" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-sun" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-moon" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]

import { ref } from 'vue';
import { useToggle } from '@vueuse/core';
import PageLogo from '@/components/PageLogo.vue';
import { isDark } from '@/constants/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageHeader',
  setup(__props) {

const toggleDark = useToggle(isDark);
const showMobileMenu = ref(false);

const toggleMobileMenu = () => {
  showMobileMenu.value = !showMobileMenu.value;
}

const hideMenu = () => {
  showMobileMenu.value = false;
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(PageLogo),
    _createElementVNode("menu", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleMobileMenu())),
          class: "group inline-block h-10 w-10 rounded-md"
        }, _hoisted_5),
        (showMobileMenu.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (hideMenu())),
                  class: "inline-block w-full border-b p-5 text-lg text-gray-500 hover:text-gray-600 dark:border-gray-800 dark:text-white",
                  to: "/"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Gas Voorraad ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (hideMenu())),
                  class: "inline-block w-full border-b p-5 text-lg text-gray-500 hover:text-gray-600 dark:border-gray-800 dark:text-white",
                  to: "/#voorraad"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Gas Voorraad (per locatie) ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (hideMenu())),
                  class: "inline-block w-full border-b p-5 text-lg text-gray-500 hover:text-gray-600 dark:border-gray-800 dark:text-white",
                  to: "/gas-prijs"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Gas prijs ")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (hideMenu())),
                  class: "inline-block w-full p-5 text-lg text-gray-500 hover:text-gray-600 dark:text-white",
                  to: "/olie-prijs"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Olie prijs ")
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("ul", _hoisted_7, [
        _createElementVNode("li", _hoisted_8, [
          _createVNode(_component_router_link, {
            class: "group flex flex-row items-center rounded p-3 text-lg hover:bg-gray-400 hover:text-white dark:hover:bg-extraDark",
            to: "/"
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _createTextVNode(" Gas voorraad ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_10, [
          _createVNode(_component_router_link, {
            class: "leading-1 group relative flex flex-col rounded p-3 first-letter:text-lg hover:bg-gray-400 hover:text-white dark:hover:bg-extraDark",
            to: "/#voorraad"
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_12, [
          _createVNode(_component_router_link, {
            class: "group flex flex-row items-center rounded p-3 text-lg hover:bg-gray-400 hover:text-white dark:hover:bg-extraDark",
            to: "/gas-prijs"
          }, {
            default: _withCtx(() => [
              _hoisted_13,
              _createTextVNode(" Gas prijs ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_14, [
          _createVNode(_component_router_link, {
            class: "group flex flex-row items-center rounded p-3 text-lg hover:bg-gray-400 hover:text-white dark:hover:bg-extraDark",
            to: "/olie-prijs"
          }, {
            default: _withCtx(() => [
              _hoisted_15,
              _createTextVNode(" Olie prijs ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_16, [
      _createElementVNode("button", {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(toggleDark)())),
        class: "dark:text-white"
      }, [
        (_unref(isDark))
          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _hoisted_19))
          : (_openBlock(), _createElementBlock("span", _hoisted_20, _hoisted_22))
      ])
    ])
  ]))
}
}

})